
import vClickOutside from 'v-click-outside';
import VueSlickCarousel from 'vue-slick-carousel';
import 'vue-slick-carousel/dist/vue-slick-carousel.css';
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css';
import qdapMallWidgetIncomeProductsQuery from '~/apollo/queries/qdap/qdapMallWidgetIncomeProduct';
import qdapMallWidgetSavingProductsQuery from '~/apollo/queries/qdap/qdapMallWidgetSavingProduct';
import eventTrackingMixins from '~/mixins/eventTrackingMixins.js';
import lgmMixin from '~/mixins/lgmMixin';
// import whatsappFn from '~/mixins/whatsappFn.js';

export default {
  name: "QdapHomeQuestionnaireProducts",
  directives: {
    clickOutside: vClickOutside.directive,
  },
  components: { VueSlickCarousel },
  mixins: [eventTrackingMixins, lgmMixin],
  props: {
    data: {
      type: Object,
      default: () => {},
    },
    stateId: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      isLoading: false,
      hasError: false,
      productLoading: true,
      carouselKey: 0,
      carouselConfig: {
        arrows: true,
        dots: true,
        infinite: false,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 1,
        touchThreshold: 5,
        autoplay: false,
      },
      inputActive: false,
      inputIncomeValue: 600,
      inputIncomeValueError: false,
      reactiveInputWidth: '3.5ch',
      productsTotalPremium: 600 * 1000,
      inputLoading: false,
      inputError: {
        min: false,
        max: false,
        number: false,
      },
      inputHighlighted: false,
    };
  },
  apollo: {
    savingProducts: {
      query: qdapMallWidgetSavingProductsQuery,
      variables() {
        return {
          age: this.savingVariables.age,
        };
      },
      prefetch: true,
      update(data) {
        return this.$normalizeStrapi(data.qdapMallWidgetSavingProducts.data);
      },
      skip() {
        const { age } = this.savingVariables;
        return (
          this.productType !== 'saving' ||
          age === null ||
          age === undefined ||
          age === ''
        );
      },
      result() {
        this.isLoading = false;
        this.hasError = false;
      },
      error() {
        this.isLoading = false;
        this.hasError = true;
      },
      loadingKey: 'isLoading',
    },
    incomeProducts: {
      query: qdapMallWidgetIncomeProductsQuery,
      variables() {
        const { age, incomeAge, incomePeriod } = this.incomeVariables;
        let incomePeriodFilter = {};

        if (incomePeriod === 999) {
          incomePeriodFilter = { gt: 20 };
        } else {
          incomePeriodFilter = { eq: incomePeriod };
        }

        return {
          age,
          incomeAge,
          incomePeriodFilter,
        };
      },
      prefetch: true,
      update(data) {
        return this.$normalizeStrapi(data.qdapMallWidgetIncomeProducts.data);
      },
      skip() {
        const { age, incomeAge, incomePeriod, totalPremium } = this.incomeVariables;
        return (
          this.productType !== 'income' ||
          age === null ||
          age === undefined ||
          incomeAge === null ||
          incomeAge === undefined ||
          incomePeriod === null ||
          incomePeriod === undefined ||
          totalPremium === null ||
          totalPremium === undefined ||
          age === '' ||
          incomeAge === '' ||
          incomePeriod === '' ||
          totalPremium === ''
        );
      },
      result() {
        this.isLoading = false;
        this.hasError = false;
      },
      error() {
        this.isLoading = false;
        this.hasError = true;
      },
      loadingKey: 'isLoading',
    }
  },
  computed: {
    questionnaireText() {
      return this.$i18n.t(`qdap.questionnaire`);
    },
    productType() {
      return this.data[4] === undefined ? 'saving' : 'income';
    },
    incomeVariables() {
      return {
        age: this.data[1],
        incomeAge: this.data[3],
        incomePeriod: this.data[4],
        totalPremium: 600,
        minPremium: 180,
        maxPremium: 10000,
      }
    },
    savingVariables() {
      return { age: this.data[1]};
    },
    productRemarks() {
      if ( this.productType === 'saving') {
        return this.questionnaireText.remarks;
      } else {
        return this.questionnaireText.assumption;
      }
    },
    incomePeriodText() {
      const periodText = this.questionnaireText.questions[3].answer;
      return {
        10: periodText[0],
        20: periodText[1],
        999: periodText[2],
      }
    },
    totalPeriodMsg() {
      const text = this.questionnaireText.productCard.totalIncome;
      return text.replace('{Y}', this.incomePeriodText[this.incomeVariables.incomePeriod]);
    },
    incomeMsg() {
      const text = this.questionnaireText.productCard.incomeMsg;
      const ageEdit = text.replace('{X}', this.incomeVariables.incomeAge);
      return ageEdit.replace('{Y}', this.incomePeriodText[this.incomeVariables.incomePeriod]);
    },
    transformedSavingProducts() {
      if (!this.savingProducts) return [];

      return this.savingProducts.map((product) => {
        const enName =
          product.insurance_company.insurance_company_translations.find(
            (t) => t.locale === 'en'
          )?.name || '';
        const zhName =
          product.insurance_company.insurance_company_translations.find(
            (t) => t.locale === 'zh-Hant-HK'
          )?.name || '';

        return {
          id: Number(product.id),
          name: product.plan_name,
          scenarioCode: product.proxy_scenario_code,
          insuranceCompany: {
            name: `${zhName} | ${enName}`,
            code: product.insurance_company.code,
            logoSrc: product.insurance_company.logo.url,
            logoAlt: zhName,
          },
          discount: product.discount_info,
          keyItems: [
            {
              key: this.questionnaireText.productCard.breakdown.year,
              value: product.guaranteed_breakeven_year + this.questionnaireText.productCard.year,
            },
            {
              key: this.questionnaireText.productCard.breakdown.guaranteedIrrY8,
              value: `${(product.guaranteed_irr_y8 * 100).toFixed(1)}%`,
              toolTipHtml: this.questionnaireText.productCard.breakdown.guaranteedIrrY8ToolTip,
            },
            {
              key: this.questionnaireText.productCard.breakdown.projectedIrrY8,
              value: `${(product.projected_irr_y8 * 100).toFixed(1)}%`,
              toolTipHtml: this.questionnaireText.productCard.breakdown.projectedIrrY8ToolTip,
            }
          ],
          mainButtonCTA: {
            link: this.generateWhatsAppLink(product)
          },
          productType: this.productType
        };
      });
    },

    transformedIncomeProducts() {
      if (!this.incomeProducts) return [];

      return this.incomeProducts.map((product) => {
        const enName =
          product.insurance_company.insurance_company_translations.find(
            (t) => t.locale === 'en'
          )?.name || '';
        const zhName =
          product.insurance_company.insurance_company_translations.find(
            (t) => t.locale === 'zh-Hant-HK'
          )?.name || '';

        const multiplier = this.productsTotalPremium / 600000;

        const firstYearAnnuity = Math.round(product.first_year_annuity * multiplier);
        const totalGIncome = Math.round(product.total_g_income * multiplier);
        const totalPIncome = Math.round(product.total_p_income * multiplier);
        const keyItemsDisplayPeriod = this.incomeVariables.incomePeriod === 999 ? this.questionnaireText.productCard.income.greaterThan20yP : this.incomePeriodText[this.incomeVariables.incomePeriod];

        return {
          id: Number(product.id),
          name: product.plan_name,
          scenarioCode: product.proxy_scenario_code,
          insuranceCompany: {
            name: `${zhName} | ${enName}`,
            code: product.insurance_company.code,
            logoSrc: product.insurance_company.logo.url,
            logoAlt: zhName,
          },
          discount: product.discount_info,
          features: [
            {
              text: product.duration_placeholder_text,
              type: 'income_term',
            },
          ],
          keyItems: [
            {
              key: this.questionnaireText.productCard.income.firstYearAnnuity,
              value: `${this.formatNumber(this.roundToThousand(firstYearAnnuity))}`,
            },
            {
              key: this.questionnaireText.productCard.income.totalGuaranteedIncome.replace('{Y}', keyItemsDisplayPeriod),
              value: `${this.formatNumber(this.roundToThousand(totalGIncome))}`,
            },
            {
              key: this.questionnaireText.productCard.income.totalProjectedIncome.replace('{Y}', keyItemsDisplayPeriod),
              value: `${this.formatNumber(this.roundToThousand(totalPIncome))}`,
            }
          ],
          mainButtonCTA: {
            link: this.generateWhatsAppLink(product)
          },
          productType: this.productType
        };
      });
    },

    currentProducts() {
      return this.productType === 'income'
        ? this.transformedIncomeProducts
        : this.transformedSavingProducts;
    },
  },
  watch: {
    inputActive(val) {
      if (val === true) {
        this.$refs.inputIncomeField.focus();
      }
    },
    transformedSavingProducts(val) {
      if (val !== null) this.productLoading = false;
    },
    transformedIncomeProducts(val) {
      if (val !== null) this.productLoading = false;
    },
    inputIncomeValueError(val) {
      if (val === false) {
        this.inputError.number = false;
        this.inputError.min = false;
        this.inputError.max = false;
      }
    },
  },
  methods: {
    formatNumber(value) {
      return value.toLocaleString('en-US');
    },

    roundToThousand(value) {
      return Math.round(value / 1000) * 1000;
    },

    generateWhatsAppLink(product) {
      const phoneNumber = '85237051599';
      let zhInsurerName, insurerName, productName;

      if (product) {
        zhInsurerName = product.insurance_company.insurance_company_translations.find(
              (t) => t.locale === 'zh-Hant-HK'
            )?.name || '';
        insurerName = zhInsurerName;
        productName = product.plan_name;
      }

      const pensionGoal = this.productType === 'saving' ? this.questionnaireText.productCard.whatsappMsg.breakdown : this.questionnaireText.productCard.whatsappMsg.income;

      const age = this.productType === 'saving' ? this.savingVariables.age : this.incomeVariables.age;

      let startAgeText = '';
      let periodText = '';
      if (this.productType === 'income') {
        startAgeText = this.questionnaireText.productCard.whatsappMsg.incomeAge.replace('{A}', this.incomeVariables.incomeAge);
        periodText = this.questionnaireText.productCard.whatsappMsg.incomePeriod.replace('{Y}', this.incomePeriodText[this.incomeVariables.incomePeriod]);
      }

      let tenYearsIncomePeriod = '';
      if (this.productType === 'income') {
        const tenYearMsg = product ? this.questionnaireText.productCard.whatsappMsg.tenYearsIncomePeriod : this.questionnaireText.productCard.whatsappMsg.tenYearsIncomePeriodInquiry;
        const tenYearValue = product ? this.formatNumber(this.inputIncomeValue) : this.formatNumber(this.incomeVariables.maxPremium);
        tenYearsIncomePeriod = tenYearMsg.replace('{Y}', tenYearValue);
      }

      // Build the message
      let message = ( product ) ? this.questionnaireText.productCard.whatsappMsg.msgLine1.replace('{N}', `${insurerName} | ${productName}`) + `\n\n` : this.questionnaireText.productCard.whatsappMsg.msgLine1Inquiry + `\n\n`;
      message += this.questionnaireText.productCard.whatsappMsg.msgLine2.replace('{A}', age) + `\n`;
      message += this.questionnaireText.productCard.whatsappMsg.msgLine3.replace('{G}', pensionGoal) + `\n`;

      if (this.productType === 'income') {
        message += `${startAgeText}\n`;
        message += `${periodText}\n`;
      }

      if (this.productType === 'income') {
        message += `${tenYearsIncomePeriod}`;
      }

      // Encode the message
      const encodedMessage = encodeURIComponent(message);

      // Generate the WhatsApp link
      return `https://api.whatsapp.com/send/?phone=${phoneNumber}&text=${encodedMessage}&type=phone_number&app_absent=0`;
    },
    resetPage() {
      this.$emit('update-page', 0);
    },
    activeIncomeInput() {
      this.inputActive = true;

      this.$nextTick(() => {
        this.focusHighlightInput();

        const section = document.getElementsByClassName('input-area')[0];
        if ( section ) {
          setTimeout(() => {
            section.scrollIntoView({ behavior: 'smooth' });
          }, 300);
        }
      })
    },
    updateInputIncomeValue() {
      if ( this.inputIncomeValue === this.incomeVariables.totalPremium || this.inputIncomeValueError ) {
        this.cancelInputAction();
        return;
      }
      this.inputLoading = true;

      // update product cards
      if ( !this.inputIncomeValueError ) {
        this.productsTotalPremium = this.incomeVariables.totalPremium * 1000;
        this.inputIncomeValue = this.incomeVariables.totalPremium;
      } else {
        this.incomeVariables.totalPremium = this.inputIncomeValue;
      }

      this.inputIncomeValueError = false;
      this.inputActive = false;
      setTimeout(() => {
        this.inputLoading = false;
      }, 1000);
    },
    cancelInputAction() {
      this.incomeVariables.totalPremium = this.inputIncomeValue;
      this.inputIncomeValueError = false;
      this.inputActive = false;
    },
    checkInputValue(event) {
      this.inputHighlighted = false;
      this.reactiveInputWidth = event.target.value.length + 0.3 +'ch';

      if (isNaN(Number(event.target.value))) {
        this.inputIncomeValueError = true;
        this.updateError('number');
        this.focusHighlightInput();
      } else if ( this.incomeVariables.totalPremium < this.incomeVariables.minPremium ) {
        this.inputIncomeValueError = true;
        this.updateError('min');
      } else if ( this.incomeVariables.totalPremium > this.incomeVariables.maxPremium ) {
        this.inputIncomeValueError = true;
        this.updateError('max');
        this.focusHighlightInput();
      }else {
        this.inputIncomeValueError = false;
      }
    },
    focusHighlightInput() {
      this.$refs.inputIncomeField.focus();
      this.$refs.inputIncomeField.select();
      this.inputHighlighted = true;
    },
    updateError(val) {
      for (const key in this.inputError) {
          this.inputError[key] = (key === val);
      }
    },
    async handleCTAClick(event) {
      const eventTrackingParams = this.handleTracking();
      const dataFromClickedElement = this.extractDataFromClickedElement(event.target)

      // await this.applyAdTrackingToWhatsappLink(this.generateWhatsAppLink());
      await this.$goToURL(dataFromClickedElement.href, false, eventTrackingParams, {
        getLGMConversionId: this.getLGMConversionId,
        injectLGMConversionId: this.injectLGMConversionId
      });
      // await this.$goToURL(this.generateWhatsAppLink(), false, eventTrackingParams);
    },
    handleTracking() {
      const eventTrackingParams = this.initEventTrackingParams();

      eventTrackingParams.a = 'open_whatsapp';
      eventTrackingParams.l =  undefined;
      eventTrackingParams.c = 'qdap_questionniare_highpremium_error';
      eventTrackingParams.xr_id = this.stateId;

      this.sendEventTracking(eventTrackingParams);

      return eventTrackingParams
    },
    // async applyAdTrackingToWhatsappLink(targetUrl) {
    //   const btnLink = targetUrl;
    //   try {
    //     if(this.isWhatsappLink(btnLink) && (this.hasAdsInCookies() || this.hasLgmadsInCookies())) {
    //       const refData = await this.$fetchWhatsappRefCode()
    //       window.open(this.adjustWhatsappLink(btnLink, refData), this.$device.isMobile ? '_self' : '_blank');
    //       return;
    //     } else {
    //       window.open(btnLink, '_blank');
    //       return;
    //     }
    //   } catch (error) {
    //     console.error('error: ', error)
    //     this.$sentry.captureException(error);
    //   }
    // }
  }
}
